import React from 'react'
import PlaybackButton from '../PlayBtn'
import TimeBar from '../TimeBar'
import './index.scss'

const Audio = ({ audioElement, audioProps }) => {
  return (
    <div className='customAudio'>
      {audioElement}
      <PlaybackButton
        onClick={audioProps.togglePlaybackStatus}
        playbackStatus={audioProps.playbackStatus}
        progress={audioProps.progress}
      />
      <TimeBar
        currentTime={audioProps.currentTime}
        isSeeking={audioProps.isSeeking}
        duration={audioProps.duration}
        progress={audioProps.progress}
        setTime={audioProps.setTime}
      />
    </div>
  )
}

export default Audio
